import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { axiosInstance } from '../../helpers'
import { toast } from 'react-toastify'
import { MergeTransaction } from '../../models/DocumentAudit/types'

export const useMergeHistory = (leaseAuditId: number) => {
    const queryClient = useQueryClient()
    const mergeHistoryKey = ['merge-history', leaseAuditId] as const

    const { data: mergeHistory, isLoading, error } = useQuery<
        MergeTransaction[]
    >({
        queryKey: mergeHistoryKey,
        queryFn: async () => {
            const response = await axiosInstance.get<MergeTransaction[]>(
                `/document-audit/merge-transactions/`,
                {
                    params: { lease_audit_id: leaseAuditId },
                },
            )

            console.log(response.data)

            return response.data
        },
        enabled: !!leaseAuditId,
    })

    const { mutateAsync: revertMergeTransaction } = useMutation({
        mutationFn: async ({
            transactionId,
            operationIds,
        }: {
            transactionId: number
            operationIds?: number[]
        }) => {
            const response = await axiosInstance.post(
                `/document-audit/merge-transactions/${transactionId}/revert/`,
                { operation_ids: operationIds },
            )
            return response.data
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: mergeHistoryKey })
            queryClient.invalidateQueries({
                queryKey: ['deliverable', leaseAuditId],
            })
            toast.success('Merge transaction reverted successfully')
        },
        onError: (error: Error) => {
            toast.error(`Error reverting merge: ${error.message}`)
        },
    })

    return {
        mergeHistory,
        isLoading,
        error,
        revertMergeTransaction,
    }
}
